<!-- Retail Products -->
@if (showHeader()) {
  <div class="flex align-items-center justify-content-between cursor-pointer" pStyleClass="@next"
    enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout"
    [hideOnOutsideClick]="true"
    [attr.data-testid]="'retail-products-header'">
    <div class="flex align-items-center justify-content-center">
      <div class="h-2rem w-2rem bg-primary text-white border-round flex align-items-center justify-content-center">
        <i class="fa fa-shopping-bag" [attr.data-testid]="'retail-products-icon'"></i>
      </div>
      <div class="ml-3">
        <h4 class="text-base mb-0 line-height-1 font-bold" [attr.data-testid]="'retail-products-title'">
          {{ 'TRANSACTION.RETAIL_PRODUCTS' | translate }}
        </h4>
        @if (!loading && (retailProductsData$ | async)) {
          <p class="mb-0 text-xs text-600" [attr.data-testid]="'retail-products-count'">
            {{(retailProductsData$ | async)?.length | number}} {{ 'RETAIL_PRODUCTS.ITEMS_COUNT' | translate }}
          </p>
        }
        @if (loading) {
          <p-skeleton width="7rem" height="0.9rem" styleClass="mt-1" [attr.data-testid]="'retail-products-skeleton'" />
        }
      </div>
    </div>
    <i class="fa fa-circle-chevron-down text-primary" [attr.data-testid]="'retail-products-chevron'"></i>
  </div>
}

<div [ngClass]="showHeader() ? 'hidden mt-2':''" [attr.data-testid]="'retail-products-content'">
  <!-- Content -->
  <app-data-grid [columnData]="retailProductsData$"
    [columns]="retailProductsTableColumns$"
    [selectable]="selectAllRetailProducts"
    (emitValue)="handleEvent($event)"
    (emitSelectValue)="handleSelectAll($event)"
    tableClasses="shadow-2 p-0 my-3"
    [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'"
    (onAction)="onActionEvent($event)"
    [EmptyState]="emptyStateComponent$"
    [paginator]="false"
    [gridName]="'retail-products-list'"
    [attr.data-testid]="'retail-products-grid'" />
  <!-- Content -->
</div>
<!-- Retail Products -->

<!-- Mark as Fulfilled Modal -->
<p-dialog
  [visible]="showFulfillmentModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{'767px': '100vw'}"
  [style]="{width: '500px'}"
  styleClass="no-header-modal"
  [attr.aria-label]="'mark-fulfilled-dialog'"
  [attr.data-testid]="'mark-fulfilled-dialog'">

  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
    <form [formGroup]="fulfillmentForm" [attr.data-testid]="'fulfillment-form'">
      <div class="relative text-center p-4">

        <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showFulfillmentModal = false"
          [attr.aria-label]="'close-dialog-button'"
        [attr.data-testid]="'close-dialog-button'"></div>

        <img width="120" class="block mx-auto" src="/assets/img/fulfillment-icon.svg" alt="Fulfillment"
          [attr.data-testid]="'fulfillment-image'" />

          <h4 class="text-base md:text-lg my-3 font-bold" [attr.data-testid]="'fulfillment-title'">
            {{'RETAIL_PRODUCTS.MARK_AS_FULFILLED'| translate}}
          </h4>
          <p class="text-600 md:w-26rem mx-auto mb-0" [attr.data-testid]="'fulfillment-message'">
            {{'RETAIL_PRODUCTS.FULFILLMENT_INFO'| translate}}
          </p>

          <div class="mt-3 p-3 surface-100 border-round text-left">
            <p class="mb-2 font-semibold" [attr.data-testid]="'product-name'">
              {{ selectedProduct?.prod_name_pri_lang }}
            </p>
            <p class="mb-1 text-sm text-600" [attr.data-testid]="'product-sku'">
              <strong>{{ 'RETAIL_PRODUCTS.SKU' | translate }}:</strong> {{ selectedProduct?.sku_code }}
            </p>
            <p class="mb-0 text-sm text-600" [attr.data-testid]="'product-quantity'">
              <strong>{{ 'RETAIL_PRODUCTS.ORDERED_QTY' | translate }}:</strong> {{ selectedProduct?.quantity }}
            </p>
          </div>

        </div>
        <!-- Content -->

        <!-- Form Content -->
        <div class="surface-100 p-4">
          <label for="fulfilled_qty" class="font-medium text-700 text-xs mb-2 block uppercase"
            [attr.data-testid]="'fulfilled-qty-label'">
            {{'RETAIL_PRODUCTS.FULFILLED_QTY'| translate}}
          </label>
          <input
            type="number"
            pInputText
            formControlName="fulfilled_qty"
            class="text-sm w-full"
            [min]="1"
            [max]="selectedProduct?.quantity || 1"
            [attr.aria-label]="'fulfilled-qty-input'"
            [attr.data-testid]="'fulfilled-qty-input'" />
            @if (fulfilledQtyFormControl.touched && fulfilledQtyFormControl.invalid) {
              <app-error-msg [errors]="fulfilledQtyFormControl.errors"
                [fieldLabel]="'RETAIL_PRODUCTS.MSG.QTY_REQUIRED' | translate"
                [attr.data-testid]="'fulfilled-qty-error'" />
            }
          </div>
          <!-- Form Content -->

          <!-- Modal Footer -->
          <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
            <button
              pButton
              pRipple
              type="button"
              [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
              class="p-button-secondary p-button-text text-sm"
              (click)="showFulfillmentModal = false"
              [attr.aria-label]="'cancel-fulfillment-button'"
              [attr.data-testid]="'cancel-fulfillment-button'">
            </button>
            <button
              pButton
              pRipple
              type="button"
              [label]="'RETAIL_PRODUCTS.MARK_FULFILLED' | translate"
              class="p-button-primary text-sm"
              [loading]="btnLoading"
              (click)="markAsFulfilled(fulfillmentForm)"
              [attr.aria-label]="'mark-fulfilled-button'"
              [attr.data-testid]="'mark-fulfilled-button'">
            </button>
          </div>
          <!-- Modal Footer -->
        </form>

      </ng-template>

    </p-dialog>
    <!-- Mark as Fulfilled Modal -->
